// extracted by mini-css-extract-plugin
export default {"menu":"GroupMembershipsStep_menu__jUhGC"};